<template>
  <div class="home">
    <h1>
      Global Non-CO₂ Greenhouse Gas
      <br />Emission Projections &amp; Mitigation Potential:
      <br />2015-2050
    </h1>
  </div>
</template>

<script>
export default {
  name: "HomeScreen",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  font-size: 2.5rem;
  font-weight: normal;
  margin-top: 15%;
}
.home {
  text-align: center;
  color: #2c3e50;
  background-image: url("../assets/home.png");
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

@media all and (max-width: 980px) {
  h1 {
    font-size: 2rem;
    margin-left: 30px;
    margin-right: 30px;
  }
}
</style>
